export default "__VITE_ASSET__HRARvUTT__"